import React, { PropsWithChildren } from "react";
import { useTabsContent } from "./useTabs";

const TabContent = (p: PropsWithChildren): React.ReactElement => {
  const { isActive } = useTabsContent();

  if (!isActive) return null;

  return <>{p.children}</>;
};

export default TabContent;
